import graphql from '@/api/graphql'
import Queries from '@/api/graphql/queries'
import Mutations from '@/api/graphql/mutations'
import { Extractor } from '@/api/utils'
import router from '@/router'

const getPlural = resource => {
  if (resource.endsWith('y')) return resource.replace(/y$/, 'ies')
  return resource + 's'
}

const Methods = {
  get:
    resource =>
    (payload = {}, options = {}) => {
      let { query = payload.id ? resource : getPlural(resource), transform = Extractor, draft, arrayStrategy } = options

      return graphql.request(Queries[query], payload, { draft, arrayStrategy }).then(transform)
    },

  mutate:
    resource =>
    (payload = {}, options = {}) => {
      let { transform = Extractor, transformPayload = true, draft, arrayStrategy } = options

      let id = payload.id,
        data

      if (transformPayload) {
        let { id: extractedId, ...rest } = payload
        data = rest
      }

      let mutation = options.mutation || (payload.id ? `${resource}Update` : `${resource}Create`)

      return graphql
        .request(Mutations[mutation], transformPayload ? { id, data } : { ...payload }, { draft, arrayStrategy })
        .then(transform)
    },

  delete:
    resource =>
    (payload = {}, options = {}) => {
      let { mutation = `${resource}Delete`, transform = Extractor, draft, arrayStrategy } = options

      return graphql.request(Mutations[mutation], payload, { draft, arrayStrategy }).then(transform)
    },
}

export { Methods }

export default function (resource, config = {}) {
  return {
    get: Methods.get(resource),
    mutate: Methods.mutate(resource),
    delete: Methods.delete(resource),
    ...config,
  }
}
